<template>
  <div class="details">
    <div class="details_head clearfix">
      <div class="details_left">
          <!-- <img :src="detailObj.img" :title="detailObj.name" :alt="detailObj.name"> -->
          <el-carousel trigger="click" height="400px" >
            <el-carousel-item v-for="(item,index) in detailObj.goodsPhotoVoList" :key="index">
              <img  :src="item.img" :title="detailObj.name" :alt="detailObj.name">
            </el-carousel-item>
          </el-carousel>
      </div>
        <div class="details_right">
          <p class="details_right_p1"><strong>{{detailObj.name}}</strong></p>
          <p class="details_right_price">需要:&nbsp;<strong>{{detailObj.score}}</strong>积分</p>
          <span class="details_right_exchange">累计兑换数量{{detailObj.exchangeNum}}个</span>
          <dl class="ColorSize" v-if="Object.keys(attributeJson).length > 0">
            <dt>请选择颜色:</dt>
            <dd>
              <el-button v-for="(val, key) in attributeJson" :key="key" :type="selectColor === key ? 'success': ''" size="small" @click="chooseColor(key,val)" >{{key}}</el-button>
            </dd>
          </dl>
          <dl class="SizeColor" v-if="Object.keys(attributeJson).length > 0">
            <dt>请选择尺寸:</dt>
            <dd>
              <el-button v-for="item in allSizeList" :key="item" size="small" :type="selectSize === item ? 'success': ''" @click="chooseSize(item)">{{item}}</el-button>
            </dd>
          </dl>
          <div id="city" v-if="detailObj.goodsClassify === 1">
            <p>在以下店铺取货</p>
             <div class="new_import_address">
              <span class="new_import_address_title">搜索店铺</span>
              <el-select
                class="new_import_address_select"
                v-model="detailValue"
                filterable
                remote
                clearable
                reserve-keyword
                placeholder="请输入店铺名称"
                :remote-method="remoteMethod"
                @change="handleChange"
                >
                <el-option
                  v-for="item in searchOptions"
                  :key="item.storeCode"
                  :label="item.storeName"
                  :value=" JSON.stringify(item)">
                </el-option>
              </el-select>
            </div>
            <div class="import_city clearfix">
              <div class="import_city_prov">
                <span>省份</span>
                <select name="" class="prov" v-model="selectProvince" @change="changeAddress($event,2)" >
                  <option value="">请选择省份</option>
                  <option v-for="item in provinceList" :key="item.id" :value="item.id">{{item.name}}</option>
                </select>
              </div>
              <div class="import_city_city">
                <span>城市</span>
                <select name="" class="city" v-model="selectCity" @change="changeAddress($event,3)">
                  <option value="">请选择城市</option>
                  <option v-for="item in cityList" :key="item.id" :value="item.id">{{item.name}}</option>
                </select>
              </div>
              <div class="import_city_area">
                <span>区域</span>
                <select name="" class="city" v-model="selectArea"  @change="changeAddress($event)">
                  <option value="">请选择区域</option>
                  <option v-for="item in areaseList" :key="item.id" :value="item.id">{{item.name}}</option>
                </select>
              </div>
              <div class="import_city_city">
                <span>店铺</span>
                <select name=""  class="city" v-model="selectStoreItem" @change="changStore($event)">
                  <option value="">请选择店铺</option>
                  <option v-for="item in storeList" :key="item.storeCode" :value="JSON.stringify(item)" address="item.detailAddr">{{item.storeName}}</option>
                </select>
              </div>
            </div>
            <div class="import_address">
              <span>详细地址</span>
              <span>{{detailedAddress}}</span>
            </div>
          </div>
          <div class="details_button">
            <button @click="_exchange">立即兑换</button>
          </div>
        </div>
      </div>
      <div class="details_content clearfix">
        <div class="details-content_left">
          <h1>同类礼品</h1>
          <ul>
            <li v-for="item in similarList" :key = item.id @click="getDetail(item.goodsTypeId,item.id)">
              <a>
              <img :src="item.img">
            </a>
              <p>{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="details-content_right" v-html="detailObj.content">
        </div>
      </div>
      <div class="successTips" v-show="isSuccessChange" @click="closeIcon()">
        <div class="success">
          <div class="successCenter">
            <img :src="detailObj.img">
            <p>{{detailObj.name}}</p>
            <p>{{detailedAddress}}</p>
            <p class="success_style">【兑换成功】</p>
          </div>
          <div class="closeIcon" @click="closeIcon()">X</div>
        </div>
      </div>
      <div v-if="isShowbtn" class="returntop" @click="backtop"> TOP </div>
    </div>
</template>
<script>
import {
  getGoodsDetail,
  getAddress,
  exchangeGifts,
  getVipInfo,
  getGoodsList,
  getStoreList
} from "@/api/api";
import common from '@/libs/common';
import MinXin from '@/components/mixins'
export default {
  name: 'Detail',
  mixins: [MinXin],
  data() {
    return {
      similarListData: {},// 同类商品集合
      detailObj: {},
      attributeJson: {}, // 样式尺码对象
      allSizeList: [], // 所有尺码去重后的集合
      selectColor:'', // 选中的颜色
      selectSize:'', // 选中的尺寸
      provinceList: [], // 省份集合
      cityList: [], // 城市集合
      areaseList:[], // 地区集合
      storeList:[],// 店铺集合
      selectProvince: '', // 选中的省份ID
      selectCity: '', // 选中的城市ID
      selectArea: '', // 选中的地区ID
      selectStoreItem: "", // 选中的地址item数据
      selectStoreCode: '', // 选中的店铺code
      detailedAddress: '', // 详细地址显示
      detailValue: '',// 搜索出的结果
      searchOptions: [], // 搜索出的结果数组
      isSuccessChange: false, // 兑换成功显示的界面
      showtop: false,
      isScore: false
    }
  },
  computed: {
    similarList() {
      if(this.similarListData.length >= 7 ){
        return this.similarListData.records.slice(0,7)
      }else {
        return this.similarListData.records
      }
    }
  },
  watch: {
     $route(){
        this.typeId = this.$route.query.id;
         const data = {
            'qp-goodsTypeId-eq': this.$route.query.id,
            'pageCurrent': 1,
            'pageSize': 15
          };
          const goodsId = this.$route.query.goodsId;
          this.getGoodsDetail(goodsId);
          this.getAddress({level:1,pid:100000});
          this.getGoodsList(data);
          },
  },
  methods: {
    loginshow() {
      this.$confirm('请登录以后再来兑换商品！', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({
          name: 'Login'
        })
      }).catch(() => {
              
      });
    },
    getGoodsDetail(goodsId){
      getGoodsDetail(goodsId).then(res => {
        this.detailObj = res.data.data;
        if(res.data.data.attributeJson){
          let attributeJson = res.data.data.attributeJson;
          let newObj = JSON.parse(attributeJson);
          let allSizeList = Object.values(newObj).flat();
          let newSetAllSizeList = new Set(allSizeList);
          var newArray = Array.from(newSetAllSizeList);
          this.attributeJson = newObj;
          this.allSizeList = newArray;
        }
      })
    },
    getAddress(param) {
      getAddress(param).then(res => {
        if(res.data.code === 0){
          if(param.level === 1){
            this.provinceList = res.data.data;
          }
          if(param.level === 2) {
            this.cityList = res.data.data;
            this.areaseList = [];
            this.storeList = [];
            this.selectStoreCode = "";
            this.detailedAddress = "";

          }
          if(param.level === 3) {
            this.areaseList = res.data.data;
            this.storeList = [];
            this.selectStoreCode = "";
            this.detailedAddress = "";
          }
        }
      })
    },
    getSelectAddress(param) {
        getAddress(param).then(res => {
        if(res.data.code === 0){
          if(param.level === 1){
            this.provinceList = res.data.data;
          }
          if(param.level === 2) {
            this.cityList = res.data.data;
          }
          if(param.level === 3) {
            this.areaseList = res.data.data;
          }
        }
      })
    },
    getGoodsList(data) {
        getGoodsList(data).then(res => {
          if(res.data.code === 0) {
           this.similarListData = res.data.data;
          }
        })
    },
    getStoreList(data){
      getStoreList(data).then(res => {
        console.log(res)
        if(res.data.code === 0){
          this.storeList = res.data.data;
          this.selectStoreCode = "";
          this.detailedAddress = "";
        }
      })
    },
    exchangeGifts(param) {
      const loading = this.$loading({
        lock: true,
        text: '兑换中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      exchangeGifts(param).then((res) => {
        if(res.data.code === 0){
          this.isSuccessChange = true;
        //  this.$message.success(`兑换成功！请前往个人中心查看！`);
        }
        
        loading.close();
      })
    },
    chooseColor(k,v){
      this.selectColor = k;
      this.selectSize = '';
      this.allSizeList = v;
    },
    chooseSize(v){
      this.selectSize = v;
    },
    getVipInfo() {
      getVipInfo().then(res => {
        if(res.data.code === 0){
          common.setUserInfo(res.data.data);
          window.location.reload();
        }
      })
    },
    changeAddress(event,level){
      const pid = event.target.value;
      if(pid){
        if(!level){
          this.getStoreList({"qp-districtId-eq":pid});
          return;
        }
        const params = {level:level,pid: event.target.value};
        this.getAddress(params);
      }

    },
    changStore(event){
      if(!event.target.value){
        this.selectStoreCode = "";
        this.detailedAddress = "";
        return;
      }
      const item = JSON.parse(event.target.value);
      this.selectStoreItem = event.target.value;
      this.selectStoreCode = item.storeCode;
      this.detailedAddress = item.detailAddr;
    },
    remoteMethod(query){
      if (query !== '') {
        const loading = this.$loading({
          lock: true,
          text: '查询中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        const data = {"qp-storeName-like": query};
        getStoreList(data).then(res => {
          loading.close();
          if(res.data.code === 0 && res.data.data.length) {
            this.searchOptions = res.data.data;
          }else{
            this.searchOptions = [];
          }
        })
      } else {
        this.searchOptions = [];
      }
    },
    handleChange(e){
      const selectItem = JSON.parse(e);
      const {cityId, provinceId, districtId, storeCode, detailAddr } = selectItem;
      this.getSelectAddress({level:2,pid: provinceId});
      this.getSelectAddress({level:3,pid: cityId});
      getStoreList({"qp-districtId-eq": districtId}).then(res => {
          if(res.data.code === 0){
            this.storeList = res.data.data;
          }
      })
      this.selectProvince = provinceId;
      this.selectCity = cityId;
      this.selectArea  = districtId;
      this.selectStoreItem = e;
      this.selectStoreCode = storeCode;
      this.detailedAddress = detailAddr;
    },
    _exchange() {
      if(!common.getToken()){
        this.loginshow();
        return;
      }
      const attributeJson = {
        [this.selectColor]:this.selectSize,
      }
      const params = {
        exchangeNum: 1,
        goodsId: this.detailObj.id,
        storeCode: this.selectStoreCode || this.detailValue,
        attributeJson: JSON.stringify(attributeJson)
      };
      if(this.detailObj.goodsClassify === 1){
        if(!this.selectStoreCode && !this.detailValue) {
          this.$message.error('请选择收货店铺！')
          return;
        }
        if(this.detailObj.attributeJson){
          if(!this.selectColor){
            this.$message.error('请选择颜色！')
            return;
          }
          if(!this.selectSize){
            this.$message.error('请选择尺寸！')
            return;
          }
        }
      }
       this.$confirm('确认兑换吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.exchangeGifts(params)
        }).catch(() => {
                 
        });
    },
    getDetail(goodsTypeId,id){
      this.$router.push({
        name: "Detail",
        query: {id:goodsTypeId,goodsId:id}
      });
    },
    closeIcon(){
      this.getVipInfo();
    }
  },
  mounted() {
    const data = {
      'qp-goodsTypeId-eq': this.$route.query.id,
      'pageCurrent': 1,
      'pageSize': 15
    };
    const goodsId = this.$route.query.goodsId;
    this.getGoodsDetail(goodsId);
    this.getAddress({level:1,pid:100000});
    this.getGoodsList(data);
  }
}

</script>
<style>

.details {
  width: 1000px;
  margin: 0 auto;
  position: relative !important;
}

.details_head {
  border-bottom: 3px solid #dcdcdc;
  width: 900px;
  margin: 20px auto;
  padding-bottom: 20px
}

.details_left {
  width: 400px;
  float: left;
  height: 400px
}

.details_left img {
  width: 100%;
  height: 100%
}

.details_right {
  float: left;
  font-size: 20px;
  width: 480px;
  margin-left: 20px
}

.details_right_p1 {
  border-bottom: 1px solid #dcdcdc;
  padding-bottom: 5px
}

.details_right_price strong {
  font-size: 30px;
  color:rgb(188, 5, 3);
}

.details_right_shopprice {
  font-size: 14px;
  text-decoration: line-through;
  margin-left: 5px;
}

.num {
  margin: 30px 0 50px 0
}

.num span {
  display: inline-block;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.num span:first-child {
  margin-right: 40px
}

.num span:not(:first-child) {
  width: 30px;
  height: 30px;
  background-color: #6d1a22;
  vertical-align: middle;
  color: #ffffff;
  text-align: center;
  line-height: 30px;
  cursor: Pointer
}

.num input {
  width: 50px;
  height: 26px;
  vertical-align: middle;
  border: 1px solid #ba9396;
  text-align: center
}

.details_button {
  margin-top: 50px
}

.details_button button {
  background-color: #000000;
  border: none;
  color: #ffffff;
  height: 50px;
  vertical-align: middle;
  width: 180px;
  cursor: Pointer
}

.details_button button span {
  width: 30px;
  display: inline-block;
  margin-right: 15px
}

.details_button button span img {
  width: 100%
}

.details_button1 {
  margin-top: 50px
}

.details_button1 button {
  background-color: gray;
  border: none;
  color: #ffffff;
  height: 50px;
  vertical-align: middle;
  width: 180px;
  cursor: Pointer
}

.details_button1 button span {
  width: 30px;
  display: inline-block;
  margin-right: 15px
}

.details_button1 button span img {
  width: 100%
}

.details_right_exchange {
  font-size: 16px;
  color: gray
}

.details_content {}

.details-content_left {
  border: 2px solid #ebebeb;
  width: 180px;
  margin-bottom: 10px;
  float: left
}

.details-content_left h1 {
  color: #969696;
  background-color: #ebebeb;
  text-align: center;
  padding: 10px;
}

.details-content_left li {
  text-align: center;
  margin: 10px 0;
  width: 180px;
  height: 200px;
  border-bottom: 1px solid #dcdcdc;
}

.details-content_left img {
  width: 100%;
  height: 80%
}

.details-content_left p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.details-content_right {
  float: right;
  width: 800px;
  border: 1px solid #dcdcdc;
  margin-bottom: 20px;
}

.details-content_right img {
  width: 100%
}

.details-content_bottom {
  border: 5px solid #DCC19A;
  margin-bottom: 5px;
}

/*选择颜色尺寸*/
.ColorSize dt {
  font-size: 16px;
  display: inline-block
}

.ColorSize dd {
  display: inline-block
}

/* .ColorSize button {
  border: none;
  padding: 5px;
  margin-right: 5px;
  font-size: 14px
}

.SizeColor button {
  border: none;
  padding: 5px;
  margin-right: 5px;
  font-size: 14px
} */

.SizeColor dt {
  font-size: 16px;
  display: inline-block
}

.SizeColor dd {
  display: inline-block
}

#city {
  margin-top: 20px;
  border-bottom: 1px solid #dcdcdc;
  border-top: 1px solid #dcdcdc;
  padding-bottom: 20px;
}

/*店铺*/
.import_city {
  font-size: 14px
}

.import_city_prov {
  float: left;
  margin-right: 5px
}

.import_city_prov span {
  border: none
    /*1px solid #3b3b3b*/
  ;
  width: 30px;
  height: 30px;
  display: inline-block;
  text-align: center;
  line-height: 30px;
  float: left;
  border-radius: 3px;
  border-right: none;
  margin-right: 5px
}

.import_city_prov select {
  border: 1px solid #000000;
  width: 80px;
  height: 32px;
  display: inline-block;
  text-align: center;
  float: left;
  border-radius: 3px;
  padding-left: 3px;
}

.import_city_city {
  float: left;
  margin-right: 5px
}

.import_city_city span {
  border: none
    /*1px solid #000000*/
  ;
  width: 30px;
  height: 30px;
  display: inline-block;
  text-align: center;
  line-height: 30px;
  float: left;
  border-radius: 3px;
  border-right: none;
  margin-right: 5px
}

.import_city_city select {
  border: 1px solid #000000;
  width: 80px;
  height: 32px;
  display: inline-block;
  text-align: center;
  float: left;
  border-radius: 3px;
  padding-left: 3px;
}

.import_city_area {
  float: left;
  margin-right: 5px
}

.import_city_area span {
  border: none
    /*1px solid #000000*/
  ;
  width: 30px;
  height: 30px;
  display: inline-block;
  text-align: center;
  line-height: 30px;
  float: left;
  border-radius: 3px;
  border-right: none;
  margin-right: 5px
}

.import_city_area select {
  border: 1px solid #000000;
  width: 80px;
  height: 32px;
  display: inline-block;
  text-align: center;
  float: left;
  border-radius: 3px;
  padding-left: 3px;
}

.import_city_search {
  float: left
}

.import_city_search span {
  border: none
    /*1px solid #000000*/
  ;
  width: 70px;
  height: 70px;
  display: block;
  text-align: center;
  line-height: 70px;
  float: left;
  border-radius: 3px;
  border-right: none;
  margin-right: 5px
}

.import_city_search input {
  border: 1px solid #000000;
  width: 200px;
  height: 60px;
  display: block;
  text-align: center;
  float: left;
  border-radius: 3px;
  padding-left: 3px;
}

.import_address {
  margin-top: 10px
}

.import_address span:first-child {
  font-size: 14px;
  display: inline-block;
  border: none
    /*1px solid #3b3b3b*/
  ;
  width: 60px;
  height: 30px;
  display: inline-block;
  text-align: left;
  line-height: 30px;
  float: left;
  border-radius: 3px;
  margin-right: 5px
}

.import_address span:last-child {
  padding-left: 5px;
  border-radius: 3px;
  font-size: 14px;
  display: inline-block;
  border: none
    /*1px solid #3b3b3b*/
  ;
  width: 400px;
  min-height: 30px;
  display: inline-block;
  text-align: left;
  line-height: 30px;
  border: 1px solid #000000
}
.new_import_address{
  margin-top: 10px;
  margin-bottom: 10px;
}
.new_import_address_title{
  float: left;
  font-size: 14px;
  display: inline-block;
  border: none;
  width: 60px;
  height: 40px;
  display: inline-block;
  text-align: left;
  line-height: 40px;
  border-radius: 3px;
  margin-right: 5px
}
.new_import_address_select{
  width: 400px;
}
/*兑换成功以后*/
.successTips {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 888;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
}

.success {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  width: 50%;
  height: 50%;
  vertical-align: middle;
  font-size: 16px;
  background-color: #fff;
}

.successCenter {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
  vertical-align: middle;
  overflow: hidden;
}

.success p:nth-child(2) {
  font-size: 16px;
  letter-spacing: 5px;
}

.success p {
  color: #000;
  margin-top: 20px;
}

.success img {
  border: 1px solid gray;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 20px;
  width: 150px;
  height: 150px;
  margin-top: 20px
}

.success p a {
  margin: 0 10px;
  font-size: 14px
}

.success_style {
  font-size: 20px;
}

.closeIcon {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 24px
}

</style>
